
  
     
       

        <div class="wrapper fadeInDown">
          <div id="formContent">

            <h3>Gracias por utilizar nuestro software</h3>


                <!-- Remind Passowrd -->
    <div id="formFooter">
    
    
        <div class="redirectToLogin">
          <span>Desea regresar?</span><a class="underlineHover" routerLink="/sign-in"> Acceder</a>
        </div>

        </div>
    
  
      </div>
    </div>

    
  

  
     



